var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-field',{staticClass:"action-bar__search"},[_c('b-input',{staticClass:"input--search",attrs:{"placeholder":_vm.placeholder,"type":"search","icon-right":"search","size":"is-medium"},on:{"input":function($event){return _vm.debounceSearch($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }